import { render, staticRenderFns } from "./ConsultationForm.vue?vue&type=template&id=647b202c"
import script from "./ConsultationForm.vue?vue&type=script&lang=js"
export * from "./ConsultationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports